<div>
	<lib-card [isInDialog]="isInDialog()" [isForm]="true" [title]="'Main data'">
		<ui-text-form-field
			[title]="'Exercise name'"
			[isRequired]="true"
			[valueAsSignal]="form.name"
			[maxLength]="50"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-text-area-form-field
			class="push-top-md"
			[title]="'Instructions'"
			[valueAsSignal]="form.instructions"
			[isInDialog]="isInDialog()"
			[maxLength]="2000"
		></ui-text-area-form-field>
	</lib-card>

	<lib-card [isInDialog]="isInDialog()" [isForm]="true" [title]="'Exercise details'" class="push-top-md">
		<ui-select-item-field
			[title]="'Target muscle group'"
			[items]="targetMuscleGroupItems"
			[valueAsSignal]="form.targetMuscleGroup"
			[isInDialog]="isInDialog()"
			[addClearButton]="true"
		></ui-select-item-field>

		<ui-select-item-field
			class="push-top-md"
			[title]="'Difficulty'"
			[items]="difficultyItems"
			[valueAsSignal]="form.difficulty"
			[isInDialog]="isInDialog()"
			[addClearButton]="true"
		></ui-select-item-field>

		<ui-select-item-field
			class="push-top-md"
			[title]="'Equipment'"
			[items]="equipmentItems"
			[valueAsSignal]="form.equipment"
			[isInDialog]="isInDialog()"
			[addClearButton]="true"
		></ui-select-item-field>

		<ui-select-item-field
			class="push-top-md"
			[title]="'Force type'"
			[items]="forceTypeItems"
			[valueAsSignal]="form.forceType"
			[isInDialog]="isInDialog()"
			[addClearButton]="true"
		></ui-select-item-field>

		<ui-select-item-field
			class="push-top-md"
			[title]="'Laterality'"
			[items]="lateralityItems"
			[valueAsSignal]="form.laterality"
			[isInDialog]="isInDialog()"
			[addClearButton]="true"
		></ui-select-item-field>
	</lib-card>

	<lib-card [isInDialog]="isInDialog()" [isForm]="true" [title]="'Images'" class="push-top-md">
		<ui-file-form-field
			[validation]="'images'"
			[isRequired]="false"
			[uploadFunction]="uploadFunction"
			[isInDialog]="isInDialog()"
			[valueAsSignal]="form.images"
			[imageCrop]="exerciseImageCrop"
			(valueChange)="handleUploadImage($event)"
			class="push-top-md"
		></ui-file-form-field>
	</lib-card>

	<lib-card [isInDialog]="isInDialog()" [isForm]="true" [title]="'Video'" class="push-top-md">
		<ui-video-form-field
			class="push-top-md"
			[valueAsSignal]="form.videoUrl"
			[isInDialog]="isInDialog()"
			[placeholder]="'Video URL'"
			[maxLength]="2000"
		></ui-video-form-field>
	</lib-card>

	<ui-form-save-button
		class="push-top-md"
		[isInDialog]="isInDialog()"
		[title]="isEditForm() ? 'Edit' : 'Create'"
		[saveHandler]="saveHandler()"
		[logHandler]="formLogHandler()"
	></ui-form-save-button>
</div>
